import * as m from "@paraglide/messages"
import type { ContentImage, SupportedLocale as Lang } from "@site-types/site"
import { localizedSettings } from "../componentUtils"
import Agency from "./Agency"
import Brands from "./Brands"
import ScrollArrow from "./ScrollArrow"
import Stage from "./Stage"
import "./styles.css"

export function Home({ locale }: { locale: Lang }) {
  const settings = localizedSettings({ additionalSettings: [] }, locale)
  const graphicText = m.home_graphicText({}, { locale: locale }) ?? ""

  return (
    <div
      className="home-content"
      data-testid="home-content"
    >
      <section className="scroll-area">
        <Stage graphicText={graphicText} />
        <ScrollArrow
          href="#agency"
          label="Scroll to agency"
        />
      </section>
      <Agency
        gamersImage={settings.homePageGamersImage as ContentImage | undefined}
        locale={locale}
      />
      <Brands
        brandImage={settings.homePageBrandImage as ContentImage | undefined}
        settings={settings}
        locale={locale}
      />
    </div>
  )
}

export default Home
